// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"palace-4"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M21 5.5V21H3V5.5L6 3L9 5.5V10H15V5.5L18 3L21 5.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M10 21V17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17V21H10Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M10 21V17C10 15.8954 10.8954 15 12 15C13.1046 15 14 15.8954 14 17V21H10Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 10V21H21V10M3 10V5.5L6 3L9 5.5V10M3 10H9M21 10V5.5L18 3L15 5.5V10M21 10H15M9 10H15","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-palace-4')
export default class Palace4Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'palace-4',
    }
  }
}
